import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=4681951e&scoped=true"
var script = {}
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=4681951e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681951e",
  null
  
)

export default component.exports